import React from 'react';
import classNames from 'classnames';

/** Predefined Options for styling the background. */
export const BackgroundStyleOptions = [
  'ask-a-nerd',
  'asteroids',
  'beige-stripes',
  'bicycles',
  'black',
  'blaetter',
  'blue',
  'blueprint-grid',
  'brokkoli',
  'default',
  'default',
  'fliesen',
  'gemalt-gruen',
  'gray-stripes',
  'hotdogs',
  'lamas-rosa',
  'lightblue',
  'lined-paper',
  'magenta',
  'mauerwerk',
  'mountains',
  'oranges',
  'rainbow',
  'skyscraper',
  'streifentapete-rot',
  'streifentapete-orange',
  'subway',
  'tischdecke',
  'waves',
  'waves-blue',
  'white',
  'wildsea',
  'wolken',
];
/** Background style type. */
type BackgroundStyle = (typeof BackgroundStyleOptions)[number];

interface BackgroundProps {
  /** ReactNode displayed as foreground. */
  children: React.ReactNode;
  /** Styling via css classes as string. */
  className?: string | string[];
  /** Predefined classes for background style. */
  styleName?: BackgroundStyle;
}

/** Renders Background behind elements. */
const Background = ({ children, className, styleName }: BackgroundProps) => {
  return (
    <div className={classNames(className, 'bg', `bg-${styleName}`)}>
      {children}
    </div>
  );
};

Background.defaultProps = {
  className: null,
  styleName: 'default',
};

export default Background;
